import { inject, Injectable } from '@angular/core';

import { DialogService } from '@hglobal/fin-ui';

import { Transfer, WalletCard } from '@kr/models';

import { TransferDetailsComponent } from './transfer-details.component';

@Injectable()
export class TransferDetailsDialog {
  readonly #dialog = inject(DialogService);

  open(transfer: Transfer, walletFrom: WalletCard, walletTo?: WalletCard) {
    return this.#dialog.open(TransferDetailsComponent, { transfer, walletFrom, walletTo }).afterClosed<boolean>();
  }
}
